import PageWrapper from '../components/agent/PageWrapper.vue'
import AgentAccountPage from '../views/agent/AgentAccountPage.vue'
import AgentDashboardPage from '../views/agent/AgentDashboardPage.vue'
import AllClientsContainer from '../views/agent/AllClientsContainer.vue'
import AgentFeedbackPage from '../views/agent/AgentFeedbackPage.vue'
import AgentCommunicationPage from '../views/agent/AgentCommunicationPage.vue'

import PlanRouteContainer from '../components/agent/plan-route/PlanRouteContainer.vue'

import NotFound404 from '../views/common/NotFound404.vue'
import AgentClientDetailPage from '../views/agent/AgentClientDetailPage.vue'

import CalendarWrapper from '../components/calendar/CalendarWrapper.vue'
import PlannerPage from '../views/agent/PlannerPage.vue'
import MobileSearchPage from '../views/common/MobileSearchPage.vue'
import InviteBuyerPage from '../views/agent/InviteBuyerPage.vue'
import AgentSearchPage from '../views/agent/AgentSearchPage.vue'

import DetailPropertyView from '../components/search/property_view/DetailPropertyView.vue'

import { agentRequireAuth } from './authorization'

export default [{
  path: 'plan-route',
  name: 'plan-route',
  component: PlanRouteContainer,
  props: true
},
{
  path: '/agent',
  component: PageWrapper,
  beforeEnter: (to, from, next) => agentRequireAuth(to, from, next),
  // Change the children array to avoid mobile users from visiting urls they shouldn't.
  children: [{
    path: 'invite-client',
    component: InviteBuyerPage,
    name: 'agent-invite-client',
    meta: {
      title: 'Invite Client'
    }
  },
  {
    path: 'account',
    name: 'agent-account',
    component: AgentAccountPage,
    meta: {
      title: 'Account'
    }
  },
  {
    path: 'home',
    redirect: 'dashboard',
    name: 'home',
    meta: {
      title: 'Dashboard'
    }
  },
  {
    path: 'dashboard',
    component: AgentDashboardPage,
    name: 'Task-Manager / Task-View',
    meta: {
      title: 'Dashboard'
    }
  },
  {
    path: 'planner',
    component: PlannerPage,
    name: 'planner',
    meta: {
      title: 'Planner'
    }
  },
  {
    path: 'search-results',
    component: MobileSearchPage,
    name: 'agent-search-results',
    meta: {
      title: 'Search Results'
    }
  },
  {
    path: 'client-detail',
    component: AgentClientDetailPage,
    name: 'client-detail',
    meta: {
      title: 'Client Detail'
    }
  },
  {
    path: 'feedback',
    component: AgentFeedbackPage,
    name: 'feedback',
    meta: {
      title: 'Feedback'
    }
  },
  {
    path: 'communication',
    component: AgentCommunicationPage,
    name: 'communication',
    meta: {
      title: 'Communication'
    }
  },
  {
    path: 'calendar',
    component: CalendarWrapper,
    name: 'calendar',
    meta: {
      title: 'Calendar'
    }
  },
  {
    path: 'client-view',
    component: AllClientsContainer,
    name: 'client-view',
    meta: {
      title: 'Client View'
    }
  },
  {
    path: 'sphere-of-influence',
    component: NotFound404,
    name: 'sphere-of-influence',
    meta: {
      title: 'Not Found'
    }
  },
  {
    path: 'search',
    component: AgentSearchPage,
    name: 'agent-search',
    meta: {
      title: 'Search'
    },
    props: true
  },
  {
    path: 'search/:homeId',
    component: DetailPropertyView,
    meta: {
      title: 'View Details'
    },
    props: true
  }
  ]
},
{
  path: '/agent',
  redirect: '/agent/dashboard'
}
]
